import { Box, Typography } from "@mui/material";
import { colorVariables, customValue } from "../../utils/colorVariable";

export const AuthLeftContent = () => {
  return (
    <Box width={"50%"} display={{ xs: "none", sm: "block" }}>
      <img
        src={`${process.env.PUBLIC_URL}/accord_knits.png`}
        alt="Logo"
        style={{
          position: "absolute",
          height: 100,
          borderBottomRightRadius: 5,
        }}
      />
      <img
        src={`${process.env.PUBLIC_URL}/image/ak_bg_image.jpeg`}
        alt="Logo"
        style={{
          height: "80vh",
          width: "100%",
          borderBottomLeftRadius: 5,
          objectFit: "cover",
        }}
      />
      <Box
        position={"absolute"}
        bottom={150}
        display={"flex"}
        flexDirection={"row"}
        gap={2}
        justifyContent={"center"}
        width={"30%"}
      >
        <Typography variant="h6" color={colorVariables.white}>
          KNITTING
        </Typography>
        <Typography variant="h6" fontWeight={"bolder"}>
          EXCELLENCE
        </Typography>
      </Box>
      <Box
        position={"absolute"}
        bottom={145}
        display={"flex"}
        flexDirection={"row"}
        gap={2}
        justifyContent={"center"}
        width={"30%"}
      >
        {[1, 2, 3].map((item) => (
          <span
            key={item}
            style={{
              height: 5,
              backgroundColor: colorVariables.gray,
              width: 65,
              borderRadius: customValue.borderRadius,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};
